;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Container, ListGroup } from 'reactstrap';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';
import JobTeaser from '../JobTeaser';

type Props = {
  dictionary: Partial<Dictionaries>;
  locale: Locale;
  matchingJobs: JobMatch[];
};

const JobsSection = ({ dictionary, locale, matchingJobs }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);

  return (
    <Container>
      <h2 className="mb-4">
        {locale === 'fr' ? (
          <>
            <span className="text-primary">{formatMessage({ id: 'pagenav-jobs' })}</span>{' '}
            {formatMessage({ id: 'thankyou_matching' })}
          </>
        ) : (
          <>
            {formatMessage({ id: 'thankyou_matching' })}{' '}
            <span className="text-primary">{formatMessage({ id: 'pagenav-jobs' })}</span>
          </>
        )}
      </h2>
      <ListGroup>
        {matchingJobs.map((matchingJob) => (
          <JobTeaser dictionary={dictionary} job={matchingJob} key={matchingJob.id} />
        ))}
      </ListGroup>
    </Container>
  );
};

export default JobsSection;
